module.exports = __webpack_public_path__ + "img/icon_sec6_05.1d4ce26c.png";